<div class="container flex-content-vc-hc">
  <div class="text-center">
    <div class="display-1 ion ion-ios-close-circle-outline text-center text-danger mb-4"></div>

    <h3 class="mt-4 text-center">
      Browser is not supported!
    </h3>
  </div>
</div>
